import {CustomerCategory} from '../customerCategory';

export function toString(this: CustomerCategory) {
    return `Deal: ${this.id}`;
}
